export default __webpack_public_path__ + "static/media/Copy of 27-get-personal.8284ed6e.jpg";